import Store from '@/store'
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector'
import i18next from 'i18next';

export default {
    setup: function () {
        let savedLocale = Store.state.locale;
        if (!savedLocale) {
            let localesArray = new I18nextBrowserLanguageDetector().detectors.navigator.lookup();
            let frIndex = localesArray.indexOf("fr");
            let enIndex = localesArray.indexOf("en");
            let isFrenchPreferredOverEnglish = frIndex !== -1 && frIndex < enIndex;
            savedLocale = Store.state.locale = isFrenchPreferredOverEnglish ? "fr" : "en";
        }
        Store.dispatch('setLocale', savedLocale);
        i18next.init({
            lng: savedLocale,
            resources: {
                en: {
                    translation: {
                        addToBasket: "Add to basket",
                        startDate: "Date de début",
                        endDate: "Date de fin",
                        name: "Name",
                        Email: "Email",
                        Phone: "Phone",
                        Messenger: "Messenger",
                        nones: "None",
                        member: "Membre",
                        admin: "Administrateur",
                        disabled: "Désactivé",
                        pending: "En attente",
                        copy: "Copy",
                        to: "to",
                        order: "Order",
                        total: "Total",
                        Total: "Total",
                        quantityShort: "Qté",
                        Qty: "Qté",
                        finish: "Finish",
                        close: 'Close',
                        ignore: "Ignore",
                        login: 'Login',
                        register: 'Register',
                        search: 'Search',
                        logout: "Logout",
                        quantity: "Quantity",
                        add: "Add",
                        confirm: "Confirm",
                        create: "Create",
                        modify: "Modify",
                        continue: "Continue",
                        cancel: "Cancel",
                        save: "Sauvegarder",
                        remove: "Remove",
                        erase: "Delete",
                        users: "Users",
                        noSearchResults: "No search results",
                        'required': "Required",
                        invalidEmail: 'invalid email',
                        min8Char: "Minimum of 8 characters",
                        max255Char: "Maximum of 255 characters",
                        noSpace: "Il ne devrait pas y avoir d'espace",
                        min1: "The minimum value is 1",
                        min0: "The minimum value is 0",
                        send: "Send",
                        change: "Change",
                        nonBinary: "Non binaire",
                        male: "Homme",
                        female: "Femme",
                        genderPreferNotAnswer: "Préfère ne pas répondre",
                        yes: "oui",
                        no: "non",
                        downloadAll: "Tout télécharger",
                        download: "Télécharger",
                        noResults: "Pas de résultats",
                        isAvailable: "Est disponible",
                        at: "à"
                    }
                },
                fr: {
                    translation: {
                        addToBasket: "Ajouter au panier",
                        startDate: "Date de début",
                        endDate: "Date de fin",
                        name: "Nom",
                        Email: "Courriel",
                        Phone: "Téléphone",
                        Messenger: "Messenger",
                        nones: "Aucune",
                        member: "Membre",
                        admin: "Administrateur",
                        disabled: "Désactivé",
                        pending: "En attente",
                        copy: "Copier",
                        to: "au",
                        order: "Commande",
                        total: "Total",
                        Total: "Total",
                        quantityShort: "Qté",
                        Qty: "Qté",
                        finish: "Terminer",
                        close: 'Fermer',
                        ignore: "Ignorer et continuer",
                        login: 'Connexion',
                        register: "S'inscrire",
                        search: 'Chercher',
                        logout: "Déconnexion",
                        quantity: "Quantité",
                        add: "Ajouter",
                        confirm: "Confirmer",
                        create: "Créer",
                        modify: "Modifier",
                        continue: "Continuer",
                        cancel: "Annuler",
                        save: "Sauvegarder",
                        remove: "Supprimer",
                        erase: "Effacer",
                        users: "Usagers",
                        noSearchResults: "Pas de résultats de recherche",
                        'required': "Requis",
                        invalidEmail: 'courriel invalide',
                        min8Char: "Minimum de 8 caractères",
                        max255Char: "Maximum de 255 caractères",
                        noSpace: "Il ne devrait pas y avoir d'espace",
                        min1: "La valeur minimale est de 1",
                        min0: "La valeur minimale est de 0",
                        send: "Envoyer",
                        change: "Modifier",
                        nonBinary: "Non binaire",
                        male: "Homme",
                        female: "Femme",
                        genderPreferNotAnswer: "Préfère ne pas répondre",
                        yes: "oui",
                        no: "non",
                        downloadAll: "Tout télécharger",
                        download: "Télécharger",
                        noResults: "Pas de résultats",
                        isAvailable: "Est disponible",
                    }
                }
            }
        });
        return i18next;
    },
    i18next: i18next,
    getLocale: function () {
        return Store.state.locale;
    }
};
